/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerInteractionSettingResponse } from '../../models/customer-interaction-setting-response';
import { GroupOrderingSettingsResponse } from '../../models/group-ordering-settings-response';
import { OrderProcessingStatusSettingResponse } from '../../models/order-processing-status-setting-response';
import { SettingResponse } from '../../models/setting-response';
import { TenantNutritionalDefaultsSettingResponse } from '../../models/tenant-nutritional-defaults-setting-response';

export interface GetSetting$Params {
  tenantId: string;
  id: 'CHECKIN_URL' | 'ORDER_STATUS_TRACKING_URL' | 'ORDER_PROCESSING_STATUS' | 'CUSTOMER_INTERACTION' | 'GROUP_ORDERING' | 'BRAND_NUTRITIONAL_DEFAULTS';
  'Active-Tenant-Identifier': string;
}

export function getSetting(http: HttpClient, rootUrl: string, params: GetSetting$Params, context?: HttpContext): Observable<StrictHttpResponse<(SettingResponse | OrderProcessingStatusSettingResponse | CustomerInteractionSettingResponse | GroupOrderingSettingsResponse | TenantNutritionalDefaultsSettingResponse)>> {
  const rb = new RequestBuilder(rootUrl, getSetting.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.path('id', params.id, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<(SettingResponse | OrderProcessingStatusSettingResponse | CustomerInteractionSettingResponse | GroupOrderingSettingsResponse | TenantNutritionalDefaultsSettingResponse)>;
    })
  );
}

getSetting.PATH = '/tenants/{tenantId}/settings/{id}';
